import { DonationListSort } from 'gql/types';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.DonorDonationCardListSorter');
export const options = [
  {
    value: DonationListSort.LastDonationDate,
    label: t('date'),
  },
];
